import MainTemplate from "../MainTemplate";
import TransactionsLeftSide from "../transactionsStack/fragments/TransactionsLeftSide";
import MessagesRightSide from "./fragments/MessagesRightSide";
import MessagesSVG from "../../../assets/message.svg";

const MessagesView = () => {
  return (
    <MainTemplate
      title="messages"
      showBadge
      LeftSideComponent={(props) => <TransactionsLeftSide {...props} />} // Transactions are use because they are the same
      MainComponent={(props) => <MessagesRightSide {...props} />}
      image={{ src: MessagesSVG, buildSrcFromConnection: false }}
      getUserInfo
    />
  );
};

export default MessagesView;
